module.exports = __webpack_public_path__ + "img/SpeakerOutlined.3c8b996f.svg";